export const standardDatetimeFormat = 'M/D/YYYY h:mm A (z)';
export const standardDateFormat = 'M/D/YYYY';

export const standardDateFnsFormat = 'M/d/yyyy';

export const standardDatetimeFnsFormat = 'M/d/yyyy h:mm a (z)';
